import React from 'react';

const variants = {
	success: 'bg-green-100 text-green-700',
	warning: 'bg-yellow-100 text-yellow-700',
	danger: 'bg-red-100 text-red-700',
	info: 'bg-blue-100 text-blue-700',
	neutral: 'bg-gray-100 text-gray-700'
};

export default function Badge({ text, variant = 'neutral', className = '' }) {
	return <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${variants[variant]} ${className}`}>{text}</span>;
}


